/* src/app/user/profile-details/profile-details.component.scss */
/*# sourceMappingURL=profile-details.component-VTQNIZEI.css.map */
